import React from 'react'
import Layout from '../layout/layout'
// import { Link } from "gatsby"
import SEO from "../layout/seo"
import './styles/schedule.scss'
import Schedule from '../components/sessionize/Schedule'
import { Link } from 'gatsby-plugin-modal-routing-3'
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

const schedule = () => {
     
    return (
        <Layout attr="schedule">
            <SEO title="Ignite Summit: Schedule" />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Ignite summit <span className="turquoise">schedule</span></h1>
                </div>
            </div>
            <div className="container header-content" >
                <p style={{
                    fontWeight: `bold`
                }}>Register for the premier Apache Ignite virtual event!</p>

                <p>This year we prepared a range of sessions for both experienced Ignite developers and those who are just starting their Ignite journey. Join us to hear inspirational Ignite use cases,  engineering deep dives, and architectural overviews in Ignite Spotlight short sessions.</p>
                <p>Also, on the day of the event, at the <Link to="/ask">"Ask an Ignite Expert"</Link> booth, Ignite committers and experienced GridGain engineers will be available to answer your questions about Apache Ignite, integrations, community life, and more.</p>
            </div>

            <div className="schedule-items">
                <div className="schedule-wrapper">
                    <div className="container">
                        
                        <Schedule />
                        
                        <div className="buttons">
                            <Link
                                to="/register"
                                className="button past"
                                asModal
                            >
                                    watch now →
                            </Link>
                      </div>
                    </div>
                </div>
            </div>
            
        </Layout>
    )
}

export default schedule